import closeModal from "../../../assets/images/modal/closeModal.png";
import {Text} from "../../../elements/text/index.js";
import SectionWrapper from "../../../layouts/SectionWrapper/index.jsx";
import {Close, CloseButtonWrapper} from "../../NewsLetter/style.js";
import {B20ModalWrapper, OverlayModal} from "./styles.js";

export const MobileOptionsModal = ({options, searchPage, handleOption, handleClose}) => {
  return (
    <OverlayModal>
      <SectionWrapper
        innerWrapperStyles={{padding: 0}}
        styles={{
          width: "100% !important",
          backgroundColor: "transparent",
        }}
      >
        <B20ModalWrapper>
          <CloseButtonWrapper onClick={handleClose}>
            <Close alt={"close-button"} src={closeModal} />
          </CloseButtonWrapper>

          <div
            style={{
              gridColumn: "1/4",
              marginTop: 32,
              marginBottom: 32,
              paddingInline: 24,
            }}
          >
            {options.map((d, i) => {
              return (
                <Text
                  key={i}
                  onClick={() => {
                    handleOption(d);
                    handleClose();
                  }}
                  style={
                    !searchPage
                      ? {
                          fontStyle: "italic",
                          marginBottom: options.length === i + 1 ? 0 : 24,
                        }
                      : {
                          fontFamily: "Manrope",

                          marginBottom: options.length === i + 1 ? 0 : 24,
                          fontWeight: 700,
                          fontSize: "1.125rem",
                        }
                  }
                  type={searchPage ? "" : "titleExtraSmall"}
                >
                  {d.label}
                </Text>
              );
            })}
          </div>
        </B20ModalWrapper>
      </SectionWrapper>
    </OverlayModal>
  );
};
